import React, {ReactElement} from 'react';
import {makeStyles} from '@material-ui/styles';
import {DEFAULT_BLACK_COLOR} from 'src/style/variable';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import HelperUtils from '@shared/utils/HelperUtils'; //  {convertToAmount}
import {Link} from '@material-ui/core';
const PayInInstallmentDetailsStyles = makeStyles({
  wrapper: {
    flex: 1,
    color: DEFAULT_BLACK_COLOR
  },
  sectionWrapper: {
    display: 'flex',
    lineHeight: '2rem',
    fontSize: '1.2rem',
    alignItems: 'center'
  },
  strong: {
    paddingLeft: '0.2rem',
    color: DEFAULT_BLACK_COLOR
  },
  changePaymentOptions: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

const PayInInstallmentDetails = (props: any): ReactElement => {
  const classes = PayInInstallmentDetailsStyles();
  const installmentDetails = useSelector(
    (state: any) => state.payments.installmentDetails
  );
  const paymentAmountDetails = useSelector(
    (state: any) => state.payments.paymentAmountDetails
  );
  const {t} = useTranslation();
  const {changePaymentPlanOptions} = props;
  const renderSection = (text: string, value: string | number): any => {
    return (
      <div className={classes.sectionWrapper}>
        <span>{text}:</span>
        <strong className={classes.strong}>{value}</strong>
      </div>
    );
  };

  const backToChangePaymentPlanOptions = () => {
    if (typeof changePaymentPlanOptions === 'function') {
      changePaymentPlanOptions();
    }
  };

  return (
    <div className={classes.wrapper} style={{display: 'flex'}}>
      <div style={{flex: 1}}>
        {/* Installment start date section  */}
        {renderSection(
          t('PAYMENT_PLANS.PLAN_FREQUENCY'),
          installmentDetails?.plan_frequency || ''
        )}

        {/* Installment start date section  */}
        {renderSection(
          t('INSTALLMENTS.INSTALMENT_START_DATE'),
          HelperUtils.formatDisplayDate(
            installmentDetails?.instalment_start_date || ''
          )
        )}
        {/* Frequency Section */}
        {renderSection(
          t('PAYMENT_PLANS.EACH_PAYMENT_AMOUNT'),
          `$${installmentDetails?.min_instalment_amount}` || ''
        )}
        {/* Number of Installment section */}
        {renderSection(
          t('INSTALLMENTS.TOTAL_INSTALLMENTS'),
          installmentDetails?.total_installments || ''
        )}
        {/* Total Amount */}
        {renderSection(
          t('INSTALLMENTS.TOTAL_AMOUNT'),
          HelperUtils.formatCurrencyAmount(
            paymentAmountDetails?.dueAmount || ''
          )
        )}
      </div>
      <div className={classes.changePaymentOptions}>
        <Link
          component="button"
          variant="body2"
          onClick={(e: any): void => {
            backToChangePaymentPlanOptions();
          }}>
          {t('PAYMENT_PLANS.CHANGE_PAYMENT_OPTIONS')}
        </Link>
      </div>
    </div>
  );
};
export default PayInInstallmentDetails;
